import "../scss/main.scss";
import { searchWaste } from "./components/searchWaste";
import { headerDropdowns } from "./components/headerDropdowns";
import { headerSearch } from "./components/headerSearch";
import { carousels } from "./components/carousels";
import { hamburger } from "./components/hamburger";
import { accordions } from "./components/accordions";
import { dropdowns } from "./components/dropdowns";
import { miniMenu } from "./components/miniMenu";
import { kindsTabs } from "./components/kindsTabs";
import { operateThumbnails } from "./components/operateThumbnails";
import { blogCategoryFilter } from "./components/blogCategoryFilter";
import { productToForm } from "./components/productToForm";
import { statsCounter } from "./components/statsCounter";
import { departmentsAccordion } from "./components/departmentsAccordion";
import { playVideo } from "./components/playVideo";
import { revealTilesOnMobile } from "./components/revealTilesOnMobile";

// import { followMenu } from './components/followMenu';

/* Defining Site URL for images, so the website works on subfolder wordpress instances as well as global/absolute instances */
if (typeof themeSettings !== "undefined") {
  __webpack_public_path__ = `${themeSettings.baseUrl}/wp-content/themes/sirema/dist/images/`;
}

document.addEventListener("DOMContentLoaded", async () => {
  carousels();
  kindsTabs();
  searchWaste();
  headerDropdowns();
  headerSearch();
  hamburger();
  accordions();
  dropdowns();
  miniMenu();
  operateThumbnails();
  blogCategoryFilter();
  productToForm();
  statsCounter();
  departmentsAccordion();
  playVideo();
  revealTilesOnMobile();
});
